import { c as _c } from "react/compiler-runtime";
import { TabsWithRoutes } from "@components/common/tabs/tabs-with-routes";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { useMembers } from "@hooks/use-members";
import { ForbiddenPage } from "@pages/forbidden-page";
import { TeamMembers } from "@pages/members/teams/team-members";
import { NotFoundPage } from "@pages/not-found-page";
import { MemberOverviewPage } from "@pages/profile/member-overview-page";
import { TeamTabs } from "@router/route-params";
import { useAppParams } from "@router/router-helper";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { fetchingTeamsFlagsSelector, getTeamByIdSelector, selectedTeamAsMemberSelector } from "@store/teams/teams-selector";
import { resetTeamState } from "@store/teams/teams-slice";
import { fetchTeamAsMember, fetchTeamDetails } from "@store/teams/teams-slice-thunk";
import { RequiredRoleCompanyLevelName } from "@utils/access-control/company/company-access-control-types";
import { OpenTabEvents } from "@utils/track-event/track-event-list";
import { useEffect } from "react";

/** Renders the team page */
export function TeamPage() {
  const $ = _c(27);
  const {
    teamId,
    teamTabs
  } = useAppParams();
  const {
    companyMembers
  } = useMembers();
  const {
    canViewTeams
  } = useHasUserValidRoleCompanyLevel();
  let t0;
  if ($[0] !== teamId) {
    t0 = getTeamByIdSelector(teamId);
    $[0] = teamId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const selectedTeam = useAppSelector(t0);
  const selectedTeamAsMember = useAppSelector(selectedTeamAsMemberSelector);
  const dispatch = useAppDispatch();
  const {
    status
  } = useAppSelector(fetchingTeamsFlagsSelector);
  let t1;
  let t2;
  if ($[2] !== dispatch || $[3] !== teamId) {
    t1 = () => {
      if (teamId) {
        dispatch(fetchTeamDetails({
          teamId
        }));
        dispatch(fetchTeamAsMember({
          teamId
        }));
      }
      return () => {
        dispatch(resetTeamState());
      };
    };
    t2 = [dispatch, teamId];
    $[2] = dispatch;
    $[3] = teamId;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  if (!canViewTeams) {
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <ForbiddenPage />;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  if (!teamTabs || !Object.values(TeamTabs).includes(teamTabs)) {
    let t3;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <NotFoundPage />;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    return t3;
  }
  let t3;
  if ($[8] !== selectedTeam || $[9] !== selectedTeamAsMember || $[10] !== status) {
    t3 = () => <MemberOverviewPage member={selectedTeamAsMember} team={selectedTeam} isLoading={status === "pending"} />;
    $[8] = selectedTeam;
    $[9] = selectedTeamAsMember;
    $[10] = status;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MemberOverviewPage member={null} isLoading={true} />;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t3) {
    t5 = {
      label: "Overview",
      route: TeamTabs.overview,
      content: t3,
      loadingContent: t4
    };
    $[13] = t3;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== companyMembers) {
    t6 = team => <TeamMembers team={team} companyMembers={companyMembers} />;
    $[15] = companyMembers;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div />;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6) {
    t8 = {
      label: "Members",
      route: TeamTabs.members,
      content: t6,
      loadingContent: t7,
      requiredRoleCompanyLevel: RequiredRoleCompanyLevelName.canViewTeams
    };
    $[18] = t6;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t5 || $[21] !== t8) {
    t9 = [t5, t8];
    $[20] = t5;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== selectedTeam || $[24] !== t9 || $[25] !== teamTabs) {
    t10 = <TabsWithRoutes selectedTab={teamTabs} trackingEventPageName={OpenTabEvents.openTeamTab} requiredAttribute={selectedTeam} tabs={t9} />;
    $[23] = selectedTeam;
    $[24] = t9;
    $[25] = teamTabs;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
}